import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const CompanyContext = createContext(null);

const STORAGE_KEY = "hrms_active_company";

export function CompanyProvider({ children }) {
  const { user } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [activeCompanyId, setActiveCompanyId] = useState(
    typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null
  );
  const [loading, setLoading] = useState(false);

  const load = async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get("/companies");
      setCompanies(data);
      if (data.length) {
        const stored = localStorage.getItem(STORAGE_KEY);
        const valid = data.find((c) => c.id === stored);
        if (!valid) {
          setActiveCompanyId(data[0].id);
          localStorage.setItem(STORAGE_KEY, data[0].id);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user && user.id) {
      load();
    } else {
      setCompanies([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const setActive = (id) => {
    setActiveCompanyId(id);
    localStorage.setItem(STORAGE_KEY, id);
  };

  const activeCompany = companies.find((c) => c.id === activeCompanyId);

  return (
    <CompanyContext.Provider value={{ companies, activeCompany, activeCompanyId, setActive, loading, reload: load }}>
      {children}
    </CompanyContext.Provider>
  );
}

export const useCompany = () => useContext(CompanyContext);
